import { render, staticRenderFns } from "./InventoryLabelList.template.vue?vue&type=template&id=c2753cfe&scoped=true&"
var script = {}
import style0 from "./InventoryLabelList.template.vue?vue&type=style&index=0&id=c2753cfe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2753cfe",
  null
  
)

export default component.exports